import { breakpointsTailwind, useBreakpoints } from "@vueuse/core";

export function useResponsive() {
  const breakpoints = useBreakpoints(breakpointsTailwind);
  const isDesktop = breakpoints.greaterOrEqual("lg");
  const isMobile = breakpoints.smaller("sm");

  return { breakpoints, isDesktop, isMobile };
}
